class Error {
    constructor(message) {
        this.message = message
        this.name = 'Error'
    }
}

export default Error
